import { useCallback } from 'react';

import {
  ApprovalStepState,
  ProposalAgent,
  ProposalProps,
  ProposalStatus,
} from '~/data/proposals/types';

export const useProposalUtils = () => {
  const getLastProposalStep = useCallback(
    (proposal?: ProposalProps): ApprovalStepState | undefined => {
      return proposal?.approvalSteps.slice(-1)[0];
    },
    [],
  );

  const getResponsibleHRProposalAgent = useCallback(
    (proposal?: ProposalProps): ProposalAgent | undefined => {
      return getLastProposalStep(proposal)?.approvers?.find((approver) => {
        return approver.roleName === 'RESPONSIBLE_HR';
      });
    },
    [getLastProposalStep],
  );

  const filterProposalsByStatus = useCallback(
    <T extends ProposalProps>(
      status: ProposalStatus[],
      proposals?: T[],
    ): T[] => {
      return (
        proposals?.filter((proposal) =>
          status.includes(proposal.proposalStatus),
        ) || []
      );
    },
    [],
  );

  return {
    getLastProposalStep,
    getResponsibleHRProposalAgent,
    filterProposalsByStatus,
  };
};
